const HTML_BLOCK_REGEX = /(<([^>\s]+)(?:\s[^>]*)?>.*?<\/\2>|<[^>\s]+(?:\s[^>]*)?\/?>)/gi;

const isAdElement = (element = {}) => element?.type === "ad" || element?.subtype === "ad";

const isAdPlaceholderBlock = (block = "") => {
  const blockText = block.replace(/<[^>]*>/g, "").trim();
  return blockText.includes('"flag":"ad_goes_here"') || blockText.includes('"flag": "ad_goes_here"');
};

const removeTrailingAdPlaceholder = (element = {}) => {
  if (element.type !== "text" || !element.text) {
    return element;
  }

  const blocks = element.text.match(HTML_BLOCK_REGEX) || [];
  const lastBlock = blocks.length ? blocks[blocks.length - 1] : "";

  if (!isAdPlaceholderBlock(lastBlock)) {
    return element;
  }

  return { ...element, text: element.text.slice(0, element.text.lastIndexOf(lastBlock)) };
};

const removeTrailingAds = (storyCards = []) => {
  const updatedCards = storyCards.map((card) => ({
    ...card,
    "story-elements": [...(card["story-elements"] || [])],
  }));

  for (let cardIndex = updatedCards.length - 1; cardIndex >= 0; cardIndex -= 1) {
    const elements = updatedCards[cardIndex]["story-elements"];

    for (let elementIndex = elements.length - 1; elementIndex >= 0; elementIndex -= 1) {
      const element = elements[elementIndex];

      if (isAdElement(element)) {
        elements.splice(elementIndex, 1);
        continue;
      }

      elements[elementIndex] = removeTrailingAdPlaceholder(element);
      return updatedCards;
    }
  }

  return updatedCards;
};

const placeTextAds = (storyCards, isDesktop) => {
  let index = 0;
  let wordCount = 0;
  const updatedStoryCards = [];
  const wordLimit = isDesktop ? 70 : 50;

  const getWordCount = (htmlString) => {
    const regex = /(<([^>]+)>)/gi;
    const result = htmlString.replace(regex, "");
    return (result.match(/\b[$]?[\w.-]+\b/g) || []).length;
  };

  const splitHtmlByTags = (htmlString) => {
    const tagBlocks = [];
    let match;
    while ((match = HTML_BLOCK_REGEX.exec(htmlString)) !== null) {
      tagBlocks.push(match[0]);
    }
    HTML_BLOCK_REGEX.lastIndex = 0;
    return tagBlocks;
  };

  for (const card of storyCards) {
    const updatedCardElements = [];
    for (const element of card["story-elements"]) {
      if (element.type === "text" && element?.text && !element.subtype) {
        const paragraphs = splitHtmlByTags(element.text);
        let updatedText = "";

        const excludedTags = ["h2"];

        for (const paragraph of paragraphs) {
          const tagMatch = paragraph.match(/^<(\w+)/i);
          const tagName = tagMatch ? tagMatch[1].toLowerCase() : null;

          updatedText += paragraph;

          if (excludedTags.includes(tagName)) continue;

          const paragraphWordCount = getWordCount(paragraph);
          wordCount += paragraphWordCount;

          if (wordCount >= wordLimit) {
            updatedText += `<p>${JSON.stringify({ flag: "ad_goes_here", index })}</p>`;
            index++;
            wordCount = 0;
          }
        }

        updatedCardElements.push({ ...element, text: updatedText });
      } else if (["question", "answer", "q-and-a"].includes(element.subtype)) {
        updatedCardElements.push(element);
        // Q&A is an indivisible placement unit, independent of its text length.
        if (element.subtype !== "question" && (element.subtype !== "q-and-a" || element.metadata?.answer)) {
          updatedCardElements.push({ type: "ad", subtype: "ad", adIndexNo: index });
          index++;
          wordCount = 0;
        }
      } else if (element.subtype === "summary" || element.type === "title") {
        wordCount += 0;
        updatedCardElements.push(element);
      } else {
        wordCount += 30;
        updatedCardElements.push(element);

        if (wordCount >= wordLimit) {
          updatedCardElements.push({ type: "ad", subtype: "ad", adIndexNo: index });
          index++;
          wordCount = 0;
        }
      }
    }

    updatedStoryCards.push({
      ...card,
      "story-elements": updatedCardElements,
    });
  }

  return removeTrailingAds(updatedStoryCards);
};

const placeMagazineAds = (storyCards, isDesktop, member) => {
  if (member && member?.id) {
    return placeTextAds(storyCards, isDesktop);
  }
  return storyCards;
};

export const modifyStory = (story, isDesktop, member) => {
  const adsPlacementWrapper = {
    text: placeTextAds,
    magazine: placeMagazineAds,
    sponsored: placeTextAds,
    default: placeTextAds,
  };
  const newCards = (adsPlacementWrapper[story["story-template"]] || adsPlacementWrapper.default)(
    story.cards,
    isDesktop,
    member
  );
  return { ...story, cards: newCards };
};
